import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { api } from "../../lib/api";
import { brandLink } from "../../components/PublicLayout";
import SEO from "../../components/SEO";

export default function BlogDetail() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    api
      .get(`/blog/${slug}`)
      .then((r) => setPost(r.data))
      .catch(() => setNotFound(true));
  }, [slug]);

  if (notFound)
    return (
      <div className="max-w-7xl mx-auto px-6 py-20 text-center text-zinc-400">Yazı bulunamadı.</div>
    );
  if (!post) return null;

  return (
    <div className="fade-in-up" data-testid="blog-detail-page">
      <SEO title={post.title} />
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <Link
          to={brandLink("/blog")}
          className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-zinc-400 hover:text-white mb-8"
        >
          <ArrowLeft size={14} /> Blog'a Dön
        </Link>
        <div className="text-xs uppercase tracking-[0.2em] text-zinc-500 mb-4">
          {new Date(post.created_at).toLocaleDateString("tr-TR")}
        </div>
        <h1 className="font-display text-3xl sm:text-5xl tracking-tighter mb-8">{post.title}</h1>
        {post.cover_image && (
          <img src={post.cover_image} alt={post.title} className="w-full h-auto mb-8 border border-white/10" />
        )}
        <div
          className="prose prose-invert max-w-none text-zinc-300 leading-relaxed whitespace-pre-wrap"
          data-testid="blog-content"
        >
          {post.content}
        </div>
      </div>
    </div>
  );
}
